/**
 * Contact Form Fields.
 * @format
 */

import {
  countryList,
  countryParentItemsList,
} from '../../form-components/lists/country-list';
import { stateList } from '../../form-components/lists/state-list';

export const careersFormFields = [
  {
    fieldTitle: 'First name',
    fieldName: 'FirstName',
    id: 'fname',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last name',
    fieldName: 'LastName',
    id: 'lname',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Country',
    fieldName: 'Country',
    id: 'country-select',
    type: 'select',
    placeholderText: 'Select a country',
    errorMessage: 'Country field required.',
    required: true,
    list: countryList,
    useNameAsLookupValue: true,
    parentItems: countryParentItemsList,
    dependencyId: 'state-select',
  },
  {
    fieldTitle: 'State or province',
    fieldName: 'State',
    id: 'state-select',
    type: 'select',
    placeholderText: 'Select a state or province',
    errorMessage: 'State or province field required.',
    required: true,
    list: stateList,
    useNameAsLookupValue: true,
    dependentField: true,
  },
  {
    fieldTitle: 'Phone number',
    fieldName: 'Phone',
    id: 'phone',
    type: 'tel',
    placeholderText: '(000) 000 0000',
    errorMessage: 'Phone number field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Work area',
    fieldName: 'Work_area',
    id: 'work-area-select',
    type: 'select',
    placeholderText: 'Select a work area',
    errorMessage: 'Work area field required.',
    required: true,
    list: [
      {
        name: 'Engineering',
        value: 'Engineering',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Research and Development',
        value: 'Research and Development',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Software Engineering',
        value: 'Software Engineering',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'IT and Digital',
        value: 'IT and Digital',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Clinical and Medical',
        value: 'Clinical and Medical',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Marketing and Market Access',
        value: 'Marketing and Market Access',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Corporate Functions',
        value: 'Corporate Functions',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Manufacturing',
        value: 'Manufacturing',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Sales',
        value: 'Sales',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
      {
        name: 'Field Service Engineering and Customer Support',
        value: 'Field Service Engineering',
        email: ['kirsten.planck@siemens-healthineers.com'],
      },
    ],
    useNameAsLookupValue: true,
    useFieldRedirect: true,
  },
];
